import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Grid, Button, ButtonToolbar, Col, Table } from 'react-bootstrap';

import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { MessageAPI } from '../../../api/datamanager/MessageAPI';
import { PlatformAPI } from '../../../api/datamanager/PlatformAPI';
import { LineAPI } from '../../../api/datamanager/LineAPI';
import { PathStopAPI } from '../../../api/datamanager/PathStopAPI';
import { MessageForm } from './MessageForm';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { PaginationBuilder } from '../../PaginationBuilder';
import { SearchBar } from '../../SearchBar';
import { SearchHelper } from '../../helpers/SearchHelper';
import { TitleRow } from '../../TitleRow';
import { storage, TOKEN_INFO } from '../../../app/Storage';
import { decode } from 'jsonwebtoken';
import { TableButton } from '../../TableButton';
import { EditionSelector } from '../../EditionSelector';
import ColumnResize from "react-table-column-resizer";

export class Messages extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            messageSelected: undefined,
            availableLines: [],
            availablePathStops: [],
            availablePlatforms: [],
            availableProviders: [],
            isAT: false,

            loadingEdition: false,
            loadingMessages: true,
            loadingLines: true,
            loadingPathStops: true,
            loadingPlatforms: true,
            showMessageFormModal: false,
            showErrorModal: false,
            showExecutingModal: false,
            filter: "",
            currentPage: 1,
            elementsPerPage: 50,

            lineInputError: null,
            stopInputError: null,
            providerInputError: null,
            startDateInputError: null,
            endDateInputError: null,
            platformInputError: null,
            textInputError: null,
            typeInputError: null,

            alertTitle: undefined,
            icon: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            alertArgument: undefined,
            executingMessage: <LoadingSpinner />,
            executingStyle: "primary",
            exectuingIcon: "transfer",
            executingTitle: "A Executar...",
            title: ''
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);

        this.getPlatforms();
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        this.setState({
            loadingEdition: true
        });
    }
    
    endUpdate() {
        this.setState({
            loadingEdition: false
        });
    }
    
    updateNetwork() {
        this.setState({
            loadingMessages: true,
            loadingLines: true,
            loadingPathStops: true
        }, () => {
            this.checkUserRole(this.context.edition);
        });
    }

    //---------------

    getMessages(providerId) {
        return MessageAPI.list(providerId)
            .catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showErrorModal: true
                })
                throw err;
            });
    }

    getMessagesCreateadByAtWithoutProvider() {
        return MessageAPI.loadCreatedByAt()
            .catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showErrorModal: true
                })
                throw err;
            });
    }

    getLines(edition, providerId) {
        return LineAPI.list(edition.network, providerId)
            .catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                })
                throw err;
            });
    }

    getPathStops(edition, providerId) {
        return PathStopAPI.list(edition.network, providerId)
            .catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                })
                throw err;
            });
    }

    getPlatforms() {
        PlatformAPI.list()
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    availablePlatforms: data,
                    loadingPlatforms: false
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                })
            });
    }

    checkUserRole(edition) {
        let { availableProviders } = this.state;
        let tokenInfo = storage.get(TOKEN_INFO);

        if (typeof tokenInfo !== 'undefined') {
            var json = JSON.parse(tokenInfo);
            tokenInfo = Object.assign({}, json);
        }

        if (tokenInfo.id_token) {
            let idToken = decode(tokenInfo.id_token);

            if (idToken.providers) {

                let auxProviders = idToken.providers.split(';');
                auxProviders.forEach(p =>
                    -1 === availableProviders.findIndex(p1 => p1.id === p.split(':')[0]) ? availableProviders.push({ id: p.split(':')[0], name: p.split(':')[1] }) : null
                );

                let totalMessages = [];
                let totalLines = [];
                let totalPathStops = [];

                let promisesMessages = [];
                let promisesLines = [];
                let promisesPathStops = [];

                //If everything has already been loaded, this means that the user cancelled some operatior, therefore we only need to get messages
                if (!(this.state.loadingLines && this.state.loadingMessages && this.state.loadingPathStops)) {
                    promisesMessages.push(this.getMessagesCreateadByAtWithoutProvider());
                    availableProviders.forEach(p => {
                        promisesMessages.push(this.getMessages(p.id));
                    });

                    Promise.all(promisesMessages).then(result => {
                        result.forEach(m =>
                            totalMessages = totalMessages.concat(JSON.parse(m))
                        );

                        this.setState({
                            messageSelected: undefined,
                            messages: totalMessages,
                            loadingMessages: false,
                            showMessageFormModal: false,
                            lineInputError: null,
                            stopInputError: null,
                            providerInputError: null,
                            startDateInputError: null,
                            endDateInputError: null,
                            platformInputError: null,
                            textInputError: null,
                            typeInputError: null
                        });
                    }).catch(() => this.setState({ loadingMessages: false }));
                } else {

                    promisesMessages.push(this.getMessagesCreateadByAtWithoutProvider());
                    availableProviders.forEach(p => {
                        promisesMessages.push(this.getMessages(p.id));
                        promisesLines.push(this.getLines(edition, p.id));
                        promisesPathStops.push(this.getPathStops(edition, p.id));
                    });

                    Promise.all(promisesMessages).then(result => {
                        result.forEach(m =>
                            totalMessages = totalMessages.concat(JSON.parse(m))
                        );

                        this.setState({
                            loadingMessages: false,
                            messages: totalMessages,
                        });
                    }).catch(() => this.setState({ loadingMessages: false }));

                    Promise.all(promisesLines).then(result => {
                        result.forEach(l =>
                            totalLines = totalLines.concat(JSON.parse(l))
                        );
                        this.setState({
                            loadingLines: false,
                            availableLines: totalLines
                        });
                    }).catch(() => this.setState({ loadingLines: false }));

                    Promise.all(promisesPathStops).then(result => {
                        result.forEach(ps =>
                            totalPathStops = totalPathStops.concat(JSON.parse(ps))
                        );
                        this.setState({
                            loadingPathStops: false,
                            availablePathStops: totalPathStops
                        });
                    }).catch(() => this.setState({ loadingPathStops: false }));

                    this.setState({
                        isAT: true,
                        availableProviders
                    });
                }
            } else {
                this.getMessages('')
                    .then(data => this.setState({
                        loadingMessages: false,
                        showMessageFormModal: false,
                        lineInputError: null,
                        stopInputError: null,
                        providerInputError: null,
                        startDateInputError: null,
                        endDateInputError: null,
                        platformInputError: null,
                        textInputError: null,
                        typeInputError: null,
                        messages: JSON.parse(data)
                    }))
                    .catch(() => this.setState({ loadingMessages: false }));

                this.getLines(edition, '')
                    .then(data => this.setState({
                        loadingLines: false,
                        availableLines: JSON.parse(data)
                    }))
                    .catch(() => this.setState({ loadingLines: false }));

                this.getPathStops(edition, '')
                    .then(data => this.setState({
                        loadingPathStops: false,
                        availablePathStops: JSON.parse(data)
                    }))
                    .catch(() => this.setState({ loadingPathStops: false }));
            }
        }
    }

    //---------------

    updateProviderMessageValue(messageSelected, availableProviders, value) {
        if ('Selecione um operador' === value) {
            messageSelected.provider = undefined;
            messageSelected.line = undefined;
            messageSelected.stop = undefined;
            messageSelected.coordX = 0;
            messageSelected.coordY = 0;

            return;
        }

        messageSelected.provider = availableProviders.filter(p => p.id === value)[0];
        return;
    }

    updateLineMessageValue(messageSelected, availableLines, availablePathStops, e, selectAll = false) {
        if(selectAll) {
            messageSelected.line = e;
            return;
        }

        if(e.length > messageSelected.line.length) {
            let lineToAdd = availableLines.filter(line => line.id === e[e.length - 1].id)[0];

            if (messageSelected.line.findIndex(line => line.id === lineToAdd.id) === -1) {
                messageSelected.line.push(lineToAdd);
            }

            return;
        }

        let newLinesArray = messageSelected.line.filter(line => e.findIndex(s => s.id === line.id) !== -1);
        messageSelected.line = newLinesArray

        if(0 === newLinesArray.length) {
            messageSelected.stop = [];
            return;
        }

        let lineStops = [];

        availablePathStops.forEach(ps => {
            let isStopAlreadyInLineStops = lineStops.some(s => s.id === ps.stop.id);
            let isStopInAnyLinePath = messageSelected.line.some(line => line.paths.some(p => p.id === ps.path.id));

            if (!isStopAlreadyInLineStops && isStopInAnyLinePath) {
                lineStops.push(ps.stop);
            }
        });

        let stops = [];
        messageSelected.stop.forEach(ps => {
            if(lineStops.some(pathStop => pathStop.id === ps.id)) {
                stops.push(ps);
            }
        });

        messageSelected.stop = stops;

        return;
    }


    updatesStopMessageValue(messageSelected, availablePathStops, e, selectAll = false) {
        if(selectAll) {
            let lineStops = [];
            availablePathStops.forEach(ps => {
                let isStopAlreadyInLineStops = lineStops.some(s => s.id === ps.stop.id);
                let isStopInAnyLinePath = messageSelected.line.some(line => line.paths.some(p => p.id === ps.path.id));

                if (!isStopAlreadyInLineStops && isStopInAnyLinePath) {
                    lineStops.push(ps.stop);
                }
            });

            messageSelected.stop = lineStops;
            return;
        }

        if(e.length > messageSelected.stop.length) {
            let stopToAdd = availablePathStops
                .filter(ps => ps.stop.id === e[e.length - 1].id)
                .map((ps) => ps.stop)[0];

            if (messageSelected.stop.findIndex(stop => stop.id === stopToAdd.id) === -1) {
                messageSelected.stop.push(stopToAdd);
            }

            return;
        }

        let newStopsArray = messageSelected.stop.filter(stop => e.findIndex(s => s.value === stop.id) !== -1);
        messageSelected.stop = newStopsArray

        return;
    }

    updatePlatformMessageValue(messageSelected, availablePlatforms, e, selectAll = false) {
        if(selectAll) {
            messageSelected.platforms = e;
            return;
        }

        if(0 === e.length) {
            messageSelected.platforms = [];
            return;
        }

        if (e.length > messageSelected.platforms.length) {
            let platformToAdd = availablePlatforms.filter(plat => plat.id === e[e.length - 1].id)[0];

            if (messageSelected.platforms.findIndex(plat => plat.id === platformToAdd.id) === -1) {
                messageSelected.platforms.push(platformToAdd);
            }

            return;
        }

        let newPlatformsArray = messageSelected.platforms.filter(plat => e.findIndex(p => p.id === plat.id) !== -1);
        messageSelected.platforms = newPlatformsArray;

        return;
    }


    updateCircleEditedMessageValue(messageSelected, e) {
        let newCircle = e.layers._layers[Object.keys(e.layers._layers)[0]];
        if (undefined !== newCircle) {
            messageSelected.radius = Number(newCircle._mRadius.toFixed(2));
            messageSelected.coordX = newCircle._latlng.lat;
            messageSelected.coordY = newCircle._latlng.lng;
        }

        return;
    }

    updateMessageValue = (e, value, selectAll = false) => {
        let { messageSelected, availableLines, availablePathStops, availablePlatforms, availableProviders } = this.state;

        switch(value) {
            case 'provider':
                this.updateProviderMessageValue(messageSelected, availableProviders, e.target.value);
                break;
            case 'line':
                this.updateLineMessageValue(messageSelected, availableLines, availablePathStops, e, selectAll);
                break;
            case 'stop':
                this.updatesStopMessageValue(messageSelected, availablePathStops, e, selectAll);
                break;
            case 'startDate':
            case 'endDate':
                messageSelected[value] = e;
                break;
            case 'platform':
                this.updatePlatformMessageValue(messageSelected, availablePlatforms, e, selectAll);
                break;
            case 'circleEdited':
                this.updateCircleEditedMessageValue(messageSelected, e)
                break;
            case 'dblClick':
                messageSelected.coordX = e.latlng.lat;
                messageSelected.coordY = e.latlng.lng;
                break;
            case 'text':
                messageSelected[value] = e;
                break;
            case 'title':
                messageSelected[value] = e.target.value;
                break;
            case 'type':
                messageSelected[value] = e.value;
                break;
            default:
                messageSelected[value] = e.target.value;
                break;
        }

        this.setState({
            messageSelected
        });
    }


    formattedDate = (date) => {
        if (date !== null && date !== undefined) {
            var aux = date.substring(0, 10)
            var newString = aux.split("-")
            var finalString = ""
            for (var i = newString.length - 1; i >= 0; i--) {
                finalString += newString[i] + '-';
            }
            return finalString.substring(0, 10);
        }
    }

    //---------------

    handleCreateClick = () => {
        this.setState({
            messageSelected: {
                provider: '', line: '', stop: '', platforms: [], type: '', text: '', version: '', httpLink: '', startDate: '', endDate: '', createdBy: '', coordX: 0, coordY: 0, radius: 20
            },
            showMessageFormModal: true,
            title: 'Criar'
        })
    }

    handleEditClick = (message) => {
        this.setState({
            messageSelected: message,
            showMessageFormModal: true,
            title: 'Editar'
        })
    }

    handleDeleteClick = (message) => {
        this.setState({
            messageSelected: message,
            showDeleteModal: true,
            alertTitle: "Aviso",
            alertMessage: `Tem a certeza que pretende eliminar a mensagem "${message.text}"?`,
            icon: 'alert',
            alertStyle: "warning"
        })
    }

    onChangePage = (page) => {
        this.setState({
            currentPage: page
        });
    }

    onChangeElementsPerPage = (elements) => {
        this.setState({
            elementsPerPage: elements
        });
    }

    saveMessage = () => {
        if (this.validInput()) {
            this.setState({
                showExecutingModal: true
            }, () => {
                const { edition } = this.context;

                if (this.state.messageSelected.id === undefined) {
                    MessageAPI.create(this.state.messageSelected)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                showMessageFormModal: false,
                                alertTitle: "Sucesso",
                                alertMessage: 'Mensagem criada com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                showErrorModal: true
                            });
                            this.checkUserRole(edition);
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                showMessageFormModal: false,
                                alertTitle: "Erro",
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            });
                            this.checkUserRole(edition);
                        });
                } else {
                    MessageAPI.update(this.state.messageSelected.id, this.state.messageSelected)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                showMessageFormModal: false,
                                alertTitle: "Sucesso",
                                alertMessage: 'Mensagem alterada com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                showErrorModal: true
                            });
                            this.checkUserRole(edition);
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                showMessageFormModal: false,
                                alertTitle: "Erro",
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            });
                            this.checkUserRole(edition);
                        });
                }
            });
        }
    }

    deleteMessage = (isToExecute) => {
        if (isToExecute) {
            this.setState({
                showDeleteModal: false,
                showExecutingModal: true
            }, () => {
                const { edition } = this.context;

                MessageAPI.delete(this.state.messageSelected.id)
                    .then(() => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Sucesso",
                            alertMessage: 'Mensagem removida com sucesso.',
                            icon: 'ok',
                            alertStyle: 'success',
                            showErrorModal: true
                        });
                        this.checkUserRole(edition);
                    }).catch((err) => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Erro",
                            alertMessage: err.message,
                            alertStyle: 'danger',
                            icon: 'remove',
                            showErrorModal: true
                        });
                        this.checkUserRole(edition);
                    })
            })
        }

        this.setState({
            showDeleteModal: false
        })
    }

    //---------------

    validInput() {
        let { startDateInputError, endDateInputError, textInputError, typeInputError, platformInputError } = this.state;
        let errors = 0;

        startDateInputError = null;
        endDateInputError = null;
        textInputError = null;
        typeInputError = null;
        platformInputError = null;

        if ("" === this.state.messageSelected.startDate || null === this.state.messageSelected.startDate) {
            startDateInputError = 'error';
            errors++;
        }

        if ("" !== this.state.messageSelected.endDate && (this.state.messageSelected.endDate < this.state.messageSelected.startDate)) {
            endDateInputError = 'error';
            errors++;
        }

        if ("" === this.state.messageSelected.text) {
            textInputError = 'error';
            errors++;
        }

        if ("" === this.state.messageSelected.type) {
            typeInputError = 'error';
            errors++;
        }

        if (0 === this.state.messageSelected.platforms.length) {
            platformInputError = 'error';
            errors++;
        }

        this.setState({
            startDateInputError,
            endDateInputError,
            textInputError,
            typeInputError,
            platformInputError
        });

        return errors > 0 ? false : true;
    }

    //---------------

    onSearch(filter) {
        this.setState({
            filter: filter
        });
    }

    clearError = () => {
        this.setState({
            showErrorModal: false,
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
        })
    }

    //---------------

    renderPlatformNames(platforms) {
        return(
            <ul>
                {platforms.map(p => <li key={p.id}>{p.name}</li>)}
            </ul>
        );
    }

    renderMessagesTable(messages) {
        let { filter } = this.state;
        const messageFilter = SearchHelper.search({
            filter: filter,
            data: messages,
            fields: ["provider.name", "line.code", "stop.name", "text", "platforms", "startDate", "endDate", "creationDate", "version", "type", "createdBy", "coordX", "coordY", "radius", "httpLink"],
            callbackComparison: [{ "startDate": this.formattedDate }, { "endDate": this.formattedDate }, { "creationDate": this.formattedDate }, { "platforms": this.renderPlatformNames }]
        });

        const totalPages = PaginationHelper.getTotalPages(messageFilter.length, this.state.elementsPerPage);
        const activePage = totalPages < this.state.currentPage ? totalPages : this.state.currentPage;
        const messagesToRender = messageFilter.sort((a, b) => a.creationDate !== b.creationDate ? a.creationDate < b.creationDate ? -1 : 1 : 0)
            .slice((activePage - 1) * this.state.elementsPerPage, activePage * this.state.elementsPerPage);

        return (
            <Grid fluid className="table-small-creens">
                <Table responsive striped hover>
                    <thead>
                        <tr>
                            <th>Operador</th>
                            <ColumnResize className="columnResizer" />
                            <th>Titulo</th>
                            <ColumnResize className="columnResizer" />
                            <th>Linhas</th>
                            <ColumnResize className="columnResizer" />
                            <th style={{paddingLeft:'40px'}}>Paragens</th>
                            <ColumnResize className="columnResizer" />
                            <th style={{paddingLeft:'35px'}}>Plataforma</th>
                            <ColumnResize className="columnResizer" />
                            <th>Data de Início</th>
                            <ColumnResize className="columnResizer" />
                            <th>Data de Fim</th>
                            <ColumnResize className="columnResizer" />
                            <th>Data de Criação</th>
                            <ColumnResize className="columnResizer" />
                            <th>Tipo</th>
                            <ColumnResize className="columnResizer" />
                            <th>Criado Por</th>
                            <ColumnResize className="columnResizer" />
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            messagesToRender.map((message, idx) =>
                                <tr key={`message-${idx}`}>
                                    <td>{undefined !== message.provider ? message.provider.name : ''}</td>
                                    <td className="column_resizer_body" />
                                    <td>{undefined !== message.title ? message.title : ''}</td>
                                    <td className="column_resizer_body" />
                                    <td>{undefined === message.line ? '' :
                                        <ul>
                                            {message.line.map(line =>
                                                <li key={line.code}>{`${line.goName} (${line.code})`}</li>
                                            )}
                                        </ul>}</td>
                                    <td className="column_resizer_body" />
                                    <td>
                                        {undefined === message.stop ? '' : 
                                            <ul>
                                                {message.stop.map(stop =>
                                                    <li key={stop.code}>{`${stop.name} (${stop.code})`}</li>
                                                )}
                                            </ul>
                                        }
                                    </td>
                                    <td className="column_resizer_body" />
                                    <td>{0 !== message.platforms.length ?
                                        this.renderPlatformNames(message.platforms) : ''}
                                    </td>
                                    <td className="column_resizer_body" />
                                    <td>{this.formattedDate(message.startDate)}</td>
                                    <td className="column_resizer_body" />
                                    <td>{this.formattedDate(message.endDate)}</td>
                                    <td className="column_resizer_body" />
                                    <td className="column_resizer_body" />
                                    <td>{this.formattedDate(message.creationDate)}</td>
                                    <td className="column_resizer_body" />
                                    <td>{message.type}</td>
                                    <td className="column_resizer_body" />
                                    <td>{message.createdBy}</td>
                                    <td className="column_resizer_body" />
                                    <td>
                                        <ButtonToolbar className="pull-right">
                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.handleEditClick(message)} />
                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteClick(message)} />
                                        </ButtonToolbar>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table >
                <PaginationBuilder currentPage={this.state.currentPage} elementsPerPage={this.state.elementsPerPage} dataLength={messageFilter.length} onChangePage={this.onChangePage}
                    onChangeElementsPerPage={this.onChangeElementsPerPage} />
            </Grid>
        );
    }

    render() {
        if (!this.state.errorLoading) {
            const { edition } = this.context;
            const { loadingPlatforms, loadingMessages, loadingLines, loadingPathStops } = this.state;

            let contents = loadingPlatforms || loadingMessages || loadingLines || loadingPathStops
                ? <LoadingSpinner />
                : this.renderMessagesTable(this.state.messages);

            return (

                <div>
                    <EditionSelector />

                    <TitleRow title="Mensagens" showSeparator={true}>
                        <Col className="padding-0" xs={2} sm={1} md={4}>
                            <ButtonToolbar className="pull-right title-row-col-btns">
                                <Button onClick={this.handleCreateClick}> CRIAR </Button>
                            </ButtonToolbar>
                        </Col>
                        <Col className="padding-0" xs={10} sm={11} md={8}>
                            <div className="search-bar">
                                <SearchBar onSearch={(a) => this.onSearch(a)} />
                            </div>
                        </Col>
                    </TitleRow>

                    <div className="margin-top-15">
                        {contents}
                    </div>

                    <MessageForm show={this.state.showMessageFormModal} messageSelected={this.state.messageSelected} availableLines={this.state.availableLines} availablePathStops={this.state.availablePathStops}
                        availablePlatforms={this.state.availablePlatforms} isAT={this.state.isAT} availableProviders={this.state.availableProviders} startDateInputError={this.state.startDateInputError}
                        endDateInputError={this.state.endDateInputError} textInputError={this.state.textInputError} typeInputError={this.state.typeInputError} platformInputError={this.state.platformInputError}
                        title={this.state.title} onChangeValue={this.updateMessageValue} onSave={this.saveMessage} onHide={() => this.checkUserRole(edition)} />

                    <HandleDialog show={this.state.showDeleteModal} title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} onExit={this.deleteMessage} />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                    <HandleMessage show={this.state.showExecutingModal} title={this.state.executingTitle} message={this.state.executingMessage} icon={this.state.exectuingIcon} style={this.state.executingStyle}
                        onHide={this.clearError} small noButtons />
                </div>
            )
        } else {
            return (
                <div>
                    <LoadingSpinner />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                </div>
            )
        }
    }
}
